import firebase from "firebase/app";
import "firebase/functions";

export type VipSpinEventStatus = "upcoming" | "open" | "closed";
export type VipSpinReason =
  | "ok"
  | "deposit-insufficient"
  | "phone-already-claimed";
export type VipSpinCreditStatus =
  | "pending"
  | "crediting"
  | "credited"
  | "failed"
  | "dispatch-failed";

export interface VipSpinClaim {
  claimId: string;
  slotIndex: number;
  /** Degrees the wheel must rotate to land on slotIndex. Computed and tested server-side. */
  rotationDeg: number;
  prize: number;
  qualifyTotal: number;
  claimedAtMs: number;
  creditStatus: VipSpinCreditStatus;
  creditedAtMs: number;
}

export interface VipSpinStatusResponse {
  eventId: string;
  eventStatus: VipSpinEventStatus;
  startAtMs: number;
  endAtMs: number;
  minDeposit: number;
  slots: number[];
  odds: { [prize: string]: number };
  spinDurationMs: number;
  qualifyTotal: number;
  eligible: boolean;
  reason: VipSpinReason;
  claim: VipSpinClaim | null;
}

export interface VipSpinDrawResponse {
  success: boolean;
  alreadyClaimed: boolean;
  claim: VipSpinClaim;
}

function vipSpinFunctions() {
  return firebase.app().functions("asia-east2");
}

export async function getVipSpinStatus(
  accessToken: string
): Promise<VipSpinStatusResponse> {
  const callable = vipSpinFunctions().httpsCallable("getVipSpinStatus");
  const result = await callable({ accessToken });
  return result.data as VipSpinStatusResponse;
}

export async function drawVipSpin(
  accessToken: string
): Promise<VipSpinDrawResponse> {
  const callable = vipSpinFunctions().httpsCallable("drawVipSpin");
  const result = await callable({ accessToken });
  return result.data as VipSpinDrawResponse;
}
